// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__apb16","productName":"Table_productName__1GzO2"};